import http from "@/api/http/http";
import axios from "axios";

export default {
  list(params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    const payloadString = Object.entries(params).map(e => e.join('=')).join('&');
    axios.get(`${process.env.VUE_APP_API}/admin/payment/list?${payloadString}`, header)
      .then(cb)
      .catch(errCb)
  },
  detail(params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.get(`${process.env.VUE_APP_API}/admin/payment/${params.id}`, header)
      .then(cb)
      .catch(errCb)
  },
  refundByPayple(params: any, cb: (response) => void, errCb: (response) => void, finallyCb: () => void) {
    const header = http.setHeaders()
    axios.put(`${process.env.VUE_APP_API}/admin/payment/refund/payple/${params.id}`, params , header)
      .then(cb)
      .catch(errCb)
      .finally(finallyCb)
  },
  refundByInicis(params: any, cb: (response) => void, errCb: (response) => void, finallyCb: () => void) {
    const header = http.setHeaders()
    axios.put(`${process.env.VUE_APP_API}/admin/payment/refund/inicis/${params.id}`, params , header)
      .then(cb)
      .catch(errCb)
      .finally(finallyCb)
  },
  downloadExcel (params: any, cb: (response) => void, errCb: (response) => void) {
    const accessToken = localStorage.ACCESS_TOKEN
    const payloadString = Object.entries(params).map(e => e.join('=')).join('&');
    axios({
      method: 'get',
      url: `${process.env.VUE_APP_API}/admin/payment/excel?${payloadString}`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(cb)
      .catch(errCb)
  },
}